// Umami is loaded from index.html and tracks page views on its own, including
// client-side route changes. This wrapper only exists for custom events.
export const trackEvent = ({ label, ...rest } = {}) => {
  if (typeof window !== "undefined" && window.umami) {
    window.umami.track(label || "event", rest);
  }
};
